import { createPaginatedKey } from "api/keys";

export const carriersKeys = {
  carriers: {
    list: createPaginatedKey("carriers"),
    details: (id: string) => ["carrier", id],
  },
};
